import React, { useEffect, useState } from 'react'
import SuperICDandCPTSearch from '../../../../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import isNull from '../../../../../../../../../../../utils/NullChecking';
// import SuperICDandCPTSearch from '../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
// import { enumUtil } from '../../../../../../../utils/Enum';
// import { ServerRequestProtected } from '../../../../../../../utils/ServerDataRequest';
// import isNull from '../../../../../../../utils/NullChecking';

const Problems = ({ widgetUtilities, ...props }) => {
    const {
        assessmentData,
        setAssessmentData,
        saveProblemsData,
        setSaveProblemsData,
        PatDxData,
        AddProblems,
        selectedDiagnosisValue,
        setSelectedDiagnosisValue,
        searchParam,
        patientID,
        API_URL,
        RecentICDs,
        // IsEditAllowed,
        // IsDeleteAllowed,
        handleAddNewICD,
    } = widgetUtilities;

    const API_URL_GENERAL = enumUtil.controller.General;

    // ─── Local State ──────────────────────────────────────────
    const [mainProblemsModal, setMainProblemsModal] = useState({ ProblemName: "" });
    const [icdBody, setIcdBody] = useState({ 
        TableName: enumUtil.enumAPITableName.Diagnosis, 
        SearchParam: '' 
    });
    const [showInActiveProblems, setShowInActiveProblems] = useState(false);
    const [lastEncounterProblems, setLastEncounterProblems] = useState({});

    // ─── Load Last Encounter Problems ─────────────────────────
    const LoadLastEncounterProblem = () => {
        if (!searchParam?.EncounterDate || !patientID) return;
        setLastEncounterProblems({});
        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.EncounterProblem,
            "ID": patientID,
            "SearchCriteria": {
                "EncounterDate": searchParam.EncounterDate
            }
        }).then((response) => {
            setLastEncounterProblems({
                EncounterDate: response?.count?.EncounterDate,
                Problems: response?.Rows || []
            });
        }).catch(() => {
            setLastEncounterProblems({});
        });
    };

    useEffect(() => {
        LoadLastEncounterProblem();
    }, [searchParam?.EncounterDate, patientID]);

    // ─── Handle Search Input Change ───────────────────────────
    const handleDeviceChange = (e) => {
        setMainProblemsModal(prev => ({ ...prev, ProblemName: e.target.value }));
        setIcdBody({ 
            TableName: enumUtil.enumAPITableName.Diagnosis, 
            SearchParam: e.target.value 
        });
    };

    // ─── Handle Add Problem With Default ICD ──────────────────
    const handleAddProblemWithDefaultICD = (selectedData) => {
        setSelectedDiagnosisValue(selectedData);
        AddProblems(null);
    };

    // ─── Handle ICD Selected From Search ─────────────────────
    const handleSelectedData = (selectedData, name, type, mode) => {
        let modal = { ...mainProblemsModal };

        if (type === 'server' && !isNull(selectedData)) {
            if (name === 'ProblemName') {
                const exists = assessmentData?.EncounterProblem?.some(
                    item => item.DiagnosisCodeID == selectedData.DiagnosisCodeID
                );
                if (exists) return;

                if (!selectedData.PatientProblemListID) {
                    selectedData.Acuity = selectedData.Acuity 
                        ? (selectedData.Acuity + "") 
                        : 'Undefined';
                    handleAddProblemWithDefaultICD(selectedData);
                    modal[name] = '';
                } else {
                    setAssessmentData(prev => {
                        let encounterLength = prev?.EncounterProblem?.length || 0;
                        const savedItem = saveProblemsData.find(
                            x => x.PatientProblemListID === selectedData.PatientProblemListID
                        );
                        let mergedData = selectedData;

                        if (savedItem && savedItem.Deleted === "true") {
                            mergedData = {
                                ...selectedData,
                                EncounterProblemID: savedItem.EncounterProblemID,
                                PatientProblemListID: savedItem.PatientProblemListID,
                                EncounterID: savedItem.EncounterID,
                                Deleted: "false"
                            };
                        }

                        const idExist = prev.EncounterProblem?.some(
                            item => item.PatientProblemListID === selectedData.PatientProblemListID
                        );

                        const updatedEncounterProblem = idExist
                            ? prev.EncounterProblem.map(item =>
                                item.PatientProblemListID === selectedData.PatientProblemListID
                                    ? { ...mergedData, recordNoClient: String(encounterLength + 1) }
                                    : item
                            )
                            : [...(prev.EncounterProblem || []), {
                                ...mergedData,
                                recordNoClient: String(encounterLength + 1)
                            }];

                        return { ...prev, EncounterProblem: updatedEncounterProblem };
                    });

                    if (!selectedData?.EncounterProblemID) {
                        selectedData.EncounterProblemID = "";
                    }

                    setSaveProblemsData(prev => {
                        const prevItem = prev.find(
                            x => x.DiagnosisCodeID === selectedData.DiagnosisCodeID
                        );
                        if (prevItem) {
                            const restoredItem = prevItem.Deleted === "true" 
                                ? { ...prevItem, Deleted: "false" } 
                                : prevItem;
                            return prev.map(item =>
                                item.PatientProblemListID === restoredItem.PatientProblemListID
                                    ? {
                                        ...item,
                                        ...selectedData,
                                        EncounterProblemID: restoredItem.EncounterProblemID,
                                        PatientProblemListID: restoredItem.PatientProblemListID,
                                        EncounterID: restoredItem.EncounterID,
                                        Deleted: restoredItem.Deleted
                                    }
                                    : item
                            );
                        }
                        const idExist = prev.some(
                            item => item.PatientProblemListID === selectedData.PatientProblemListID
                        );
                        if (idExist) {
                            return prev.map(item =>
                                item.PatientProblemListID === selectedData.PatientProblemListID 
                                    ? selectedData 
                                    : item
                            );
                        }
                        return [...prev, selectedData];
                    });
                }
            }
        } else {
            modal[name] = '';
        }

        setMainProblemsModal(modal);
        return selectedData;
    };

    // ─── Handle Problem Delete ────────────────────────────────
    const handleProblemDelete = (item) => {
        const { DiagnosisCodeID } = item;

        setAssessmentData(prev => {
            const filteredEncounterProblem = (prev.EncounterProblem || []).filter(
                p => p.DiagnosisCodeID !== DiagnosisCodeID
            );
            return { ...prev, EncounterProblem: filteredEncounterProblem };
        });

        setSaveProblemsData(prev => {
            let found = false;
            const updated = prev.reduce((acc, p) => {
                if (p.DiagnosisCodeID === DiagnosisCodeID) {
                    found = true;
                    if (!isNull(p.EncounterProblemID)) {
                        acc.push({ ...p, Deleted: "true" });
                    }
                } else {
                    acc.push(p);
                }
                return acc;
            }, []);

            if (!found) {
                updated.push({
                    DiagnosisCodeID: item?.DiagnosisCodeID,
                    EncounterID: item?.EncounterID,
                    EncounterProblemID: item?.EncounterProblemID,
                    PatientProblemListID: item?.PatientProblemListID,
                    Deleted: "true",
                });
            }
            return updated;
        });
    };

    // ─── Handle Apply Last Encounter Problems ─────────────────
    const handleApplyProblems = () => {
        const getNewProblems = (existingList = [], type) => {
            const existingCodes = new Set(existingList.map(prob => prob.DiagnosisCode));
            let updatedArr = (lastEncounterProblems?.Problems || [])
                .filter(prob => !existingCodes.has(prob.DiagnosisCode))
                .map(({ EncounterID, ...it }) => it);

            updatedArr = updatedArr.map(prob => {
                const prevItem = existingList.find(x => x.DiagnosisCode === prob.DiagnosisCode);
                if (prevItem) {
                    const restoredItem = prevItem.Deleted === "true" 
                        ? { ...prevItem, Deleted: "false" } 
                        : prevItem;
                    return {
                        ...prob,
                        EncounterProblemID: restoredItem.EncounterProblemID,
                        PatientProblemListID: restoredItem.PatientProblemListID,
                        Deleted: restoredItem.Deleted
                    };
                }
                return prob;
            });

            if (type === 'Save') {
                let viewExistingCodes = new Set(
                    (assessmentData?.EncounterProblem || []).map(prob => prob.DiagnosisCode)
                );
                updatedArr = updatedArr.map(prob => {
                    if (viewExistingCodes.has(prob.DiagnosisCode)) {
                        let viewItem = assessmentData.EncounterProblem.find(
                            assessProb => prob.DiagnosisCode === assessProb.DiagnosisCode
                        );
                        return {
                            ...prob,
                            EncounterID: viewItem.EncounterID,
                            EncounterProblemID: viewItem.EncounterProblemID,
                            PatientProblemListID: viewItem.PatientProblemListID
                        };
                    }
                    return prob;
                });
            }
            return updatedArr;
        };

        setSaveProblemsData(prev => {
            const saveExisting = [...getNewProblems(prev, 'Save')];
            return [...prev, ...saveExisting];
        });

        setAssessmentData(prev => {
            const existingList = prev?.EncounterProblem || [];
            const newProbs = [...existingList, ...getNewProblems(existingList, 'View')];
            return { ...prev, EncounterProblem: newProbs };
        });
    };

    // ─── Show Hide InActive ───────────────────────────────────
    const ShowHideInActive = () => {
        const condition = (item) => item.isActive === "false";
        const inActiveCount = assessmentData?.EncounterProblem?.filter(condition).length;
        return inActiveCount > 0
            ? <p
                className='heading validate-color cursor-pointer'
                onClick={() => setShowInActiveProblems(prev => !prev)}
              >
                {showInActiveProblems 
                    ? `Hide InActive(${inActiveCount})` 
                    : `Show InActive(${inActiveCount})`}
              </p>
            : null;
    };

    // ─── Render ───────────────────────────────────────────────
    return (
        <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='d-flex flex-column gap-1 w-100'>
            <div className="d-flex justify-content-between align-items-center">
                <p className="heading fs-13">Problems</p>
                <div className="d-flex gap-2 align-items-center">

                    {/* Last Encounter Problems Apply */}
                    <div className="all_problems-preview position-relative">
                        {lastEncounterProblems?.Problems?.length > 0 &&
                            <>
                                <p
                                    className='text validate-color br-right-1 br-clr pe-2 cursor-pointer user-select-none'
                                    onClick={handleApplyProblems}
                                >
                                    {lastEncounterProblems?.EncounterDate} - Problems
                                </p>
                                <div className="problem-content d-flex flex-column gap-2 hover-scrollbar">
                                    {lastEncounterProblems?.Problems?.map((prob, i) => (
                                        <div key={i} className="d-flex align-items-center justify-content-between gap-20">
                                            <p className="text font-m">{prob.DiagnosisCode}</p>
                                            <p className="text font-m text-nowrap singleLine-ellispis">
                                                {prob?.Description}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </>
                        }
                    </div>

                    {/* ICD Search */}
                    <div className='input claims_info problems-search'>
                        <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                        <div className="position-relative za-denied-status Icds">
                            <SuperICDandCPTSearch
                                type='server'
                                key={PatDxData?.length}
                                placeholder={'Add Problem'}
                                customData={RecentICDs}
                                id='Dx'
                                name='ProblemName'
                                onChange={handleDeviceChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainProblemsModal?.ProblemName}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display' },
                                    { columName: 'Description', bindingValue: 'Description' },
                                ]}
                                ApiLink={API_URL + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                PatDxData={PatDxData}
                                showPatDx={true}
                                DefaultActiveTab='MyDXList'
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Problems List */}
            {assessmentData?.EncounterProblem?.length > 0 && (
                <div className="d-flex flex-column gap-2 hover-scrollbar problem-scroll px-1-5 py-2 assesment-box">
                    {assessmentData.EncounterProblem.map((prob, idx) => {
                        const inActive = prob?.isActive ? !(prob.isActive === "true") : false;
                        if (inActive && !showInActiveProblems) return null;
                        return (
                            <div key={idx} className="d-flex align-items-center justify-content-between gap-1">
                                <div className="d-flex align-items-center gap-1 w-100">
                                      {["true", "True"].includes(prob?.MarkAsPrimary) &&
                                        <div className="app_tooltip right">
                                            <i className='icon-Star fs-11'></i>
                                            <p class="tool_tip xsm_text text-light">Primary Problem</p>
                                        </div>}
                                    <p
                                        className="text validate-color cursor-pointer font-m"
                                        onClick={() => AddProblems(prob.PatientProblemListID, prob)}
                                    >
                                        {prob.DiagnosisCode}
                                    </p>
                                    {prob.Description &&
                                        <p className="text singleLine-ellispis"> - {prob.Description}</p>
                                    }
                                </div>
                                <div className="d-flex gap-10 align-items-center ps-10">
                                    <div className="d-flex align-items-center gap-1 text-nowrap">
                                        {prob.isActive === "false" &&
                                            <p className="text Partialdenied-clr fst-italic text-nowrap pe-1">
                                                InActive
                                            </p>
                                        }
                                        {prob.StartDate &&
                                            <>
                                                <p className="text font-m">Start Date:</p>
                                                <p className="text">{prob.StartDate}</p>
                                            </>
                                        }
                                    </div>
                                    <div className="lh-1">
                                        <i
                                            className='icon-x-cros fs-20 dark-clr'
                                            onClick={() => handleProblemDelete(prob)}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <ShowHideInActive />
                </div>
            )}
        </div>
        </div>
    );
};

export default Problems;